import React from "react";
import { useSelector } from "react-redux";
import { TRANSIT_CARD_CONFIG } from "../../utils/transitSiteCardsConfig";
import { getTransitAnalytics } from "../../helpers/transitAnalytics";
import { SearchTransitCylinder } from "./SearchTransitCylinder";
import ExportButton from "../../../../components/exportExcel/ExportButton";
import { formatTransitExcelData } from "../../utils/excelFormatters";

export const TransitSummaryCards = () => {
  const originalData = useSelector((state) => state.data.copyData);
  const stats = getTransitAnalytics(originalData);

  // ...............get  excel data............
  const excelData = formatTransitExcelData(originalData);
  const excelConfig = {
    data: excelData,
    fileName: "Cylinders_Transit_Report",
    sheetName: "Unvisited Sites",
  };

  return (
    <div className="flex gap-2 mt-2">
      {TRANSIT_CARD_CONFIG.map((card, index) => {
        const Icon = card.icon;
        return (
          <div key={index} className="w-[50%] white-card">
            {/* Icon */}
            <div className={`p-2 rounded-md ${card.bg}`}>
              <Icon className={card.color} />
            </div>

            {/* Content */}
            <div>
              <h3 className={`${card.color} text-xl font-bold`}>
                {stats[card.key]}
              </h3>
              <p className="text-xs lg:text-[14px] font-figtreeMedium text-[#6b7aab]">
                {card.title}
              </p>
            </div>
          </div>
        );
      })}
      <SearchTransitCylinder />
      <div className="w-[30%] white-card">
        <ExportButton excelConfig={excelConfig} />
      </div>
    </div>
  );
};
